<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "zakatAllocation",
  data() {
    return {};
  },
  created() {}
};
</script>
